import { showErrorResponse } from "../../app/utils/common/Functions";
import { getTeamOnLeaveAPI } from "../Apis/dashboard";

export const dashboardReducer = (builder) => {
  builder
    .addCase(getTeamOnLeaveAPI.pending, (state) => {
      state.loading = true;
    })
    .addCase(getTeamOnLeaveAPI.fulfilled, (state, action) => {
      state.loading = false;
      state.allPendingLeaves = action.payload?.data?.leaveRequests ?? [];
    })
    .addCase(getTeamOnLeaveAPI.rejected, (state, action) => {
      state.loading = false;
      state.allPendingLeaves = [];
      showErrorResponse(action.payload);
    });
};
